var map = {
	"./3rdParty.svg": 247,
	"./Accident.svg": 248,
	"./Bicycle.svg": 249,
	"./Boat.svg": 250,
	"./Buildings.svg": 251,
	"./Car.svg": 252,
	"./Child.svg": 253,
	"./Content.svg": 254,
	"./Contents.svg": 255,
	"./CriticalIllness.svg": 256,
	"./Dental.svg": 257,
	"./Drone.svg": 258,
	"./ExtendedWarranty.svg": 259,
	"./Family.svg": 260,
	"./Gadget.svg": 261,
	"./Health.svg": 262,
	"./Hospitalização.svg": 263,
	"./Housekeeper.svg": 264,
	"./Hunter.svg": 265,
	"./Income.svg": 266,
	"./Investment.svg": 267,
	"./Life.svg": 268,
	"./LocalLodging.svg": 269,
	"./Mobile.svg": 270,
	"./Mortgage.svg": 271,
	"./Motorbike.svg": 272,
	"./Other.svg": 273,
	"./PPR.svg": 274,
	"./Pet.svg": 275,
	"./Scooter.svg": 276,
	"./Sports.svg": 277,
	"./Thirdpartypet.svg": 278,
	"./Travel.svg": 279,
	"./Warranty.svg": 280,
	"./White_goods.svg": 281,
	"./WorkAccident.svg": 282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;